import { useLocation, useParams } from 'react-router';
import { useEffect } from 'react';

import { ChevronLeftIcon } from '@/assets/icons';
import { Button, Loading } from '@/components/common';
import { AppRoutes } from '@/constants';
import { navigate } from '@/providers';

import CheckInLogDetailsCard from './CheckInLogDetailsCard';
import { useCheckInLogDetailsQuery } from '@/features/check-in-logs/hooks';
import { formatDate } from '@/utils';

const CheckInLogDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const { data, error, isFetching } = useCheckInLogDetailsQuery(id || '');
  const formattedDate = formatDate({
    date: new Date(data?.timestamp ?? ''),
    hasTime: true,
  });

  useEffect(() => {
    if (error || (!isFetching && !data)) {
      navigate(AppRoutes.NOT_FOUND, { replace: true });
    }
  }, [error, isFetching, data]);

  return (
    <div className="flex flex-col gap-base mt-xl mb-24 text-brand-primary-darkest">
      {/* Back Button */}
      <Button
        variant="link"
        className="text-neutral-n7 self-start"
        prefixIcon={<ChevronLeftIcon />}
        onClick={() => {
          const hasHistory = location.key !== 'default';
          if (hasHistory) {
            window.history.back();
          } else {
            navigate(AppRoutes.CHECK_IN_LOGS);
          }
        }}
      >
        Back to Check-in Logs
      </Button>

      {/* Header with Title */}
      {data && (
        <h1
          className="text-h1 font-bold pb-base-plus text-ellipsis flex-1 overflow-hidden whitespace-nowrap"
          title={formattedDate}
        >
          {formattedDate}
        </h1>
      )}

      {/* Details Card */}
      {isFetching && <Loading fullScreen />}
      {data && <CheckInLogDetailsCard checkInLogDetails={data} />}
    </div>
  );
};

export default CheckInLogDetails;
